import React from 'react';
import { useParams } from 'react-router-dom';
import ScrollToTop from '../components/ScrollToTop';
import SocialLinks from '../components/SocialLinks';
import team from '../team-data/team';
import SEO from '../components/SEO';


const TeamUserBio = () => {
  const { slug } = useParams();
  const user = team[slug]

  if (!user) {
    return <p>Page not found</p>;
  }

  const seoTitle = `${user.fullName}: ${user.title}`
  const seoDescription = `${user.bio}`
  const seoKeyWords = `We-flare, weflare, ${user.title}`

  return (
    <>
      <SEO 
        title={seoTitle}
        description={seoDescription}
        keywords={seoKeyWords}
      />
      <ScrollToTop />
      <div className='bio-page container p-2'>
          <p className="text-center">
            <img src={user.userImage} alt={user.fullName} className="circle-image custom-shadow-primary" />
          </p>
          <h5 className='h4 text-center mt-2'>{user.fullName}</h5>
          <h5 className='h5 text-center'>{user.title}</h5>
          <div className="row justify-content-center mt-1">
              <div className="col-sm-12 col-md-8 col-lg-8 text-center lead">
                  <div dangerouslySetInnerHTML={{ __html: user.bio }} />
                  <div className="mt-3"></div>
                  {user.socialLinks && Object.keys(user.socialLinks).length > 0 && (
                    <SocialLinks socialLinks={user.socialLinks} />
                  )}
              </div>
          </div>
      </div>
    </>
  );
};

export default TeamUserBio;
